import { render, staticRenderFns } from "./PlayerTrade.vue?vue&type=template&id=420cd2c6&scoped=true&"
import script from "./PlayerTrade.vue?vue&type=script&lang=js&"
export * from "./PlayerTrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420cd2c6",
  null
  
)

export default component.exports